<template>
  <v-container>
    <v-row>
      <v-col class="px-0" cols="12">
        <v-card class="pa-3" color="rgba(255,255,255,0.2)">
          <v-card class="mb-2" light>
            <v-card-text class="pa-3">
              <span class="body-1">To:</span>
              <v-chip :key="email"
                      class="mx-1"
                      v-for="(email) in to"
              >{{ email }}
              </v-chip>
            </v-card-text>
          </v-card>
          <v-card class="mb-2" light v-if="cc">
            <v-card-text class="pa-3">
              <span class="body-1">Cc:</span>
              <v-chip :key="email"
                      class="mx-1"
                      v-for="(email) in cc"
              >{{ email }}
              </v-chip>
            </v-card-text>
          </v-card>
          <v-form ref="emailForm" v-if="innerValue" v-model="emailFormIsValid">
            <v-text-field :rules="rules"
                          :value="innerValue.subject"
                          @input="emitValue($event, 'subject')"
                          background-color="white"
                          class="elevation-2 mb-2"
                          @paste.prevent
                          hide-details
                          light
                          outlined
                          :prefix="$t('components.answers.email.subject')+' '"
                          style="color: grey;"
            ></v-text-field>
            <v-textarea :rules="rules"
                        :value="innerValue.body"
                        @input="emitValue($event, 'body')"
                        background-color="white"
                        @paste.prevent
                        class="elevation-2"
                        hide-details
                        light
                        no-resize
                        outlined
                        :placeholder="$t('components.answers.email.body')"
                        rows="10"
            ></v-textarea>
          </v-form>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
    export default {
        name: "Email",
        props: {
            value: {required: true},
            to: {type: Array},
            cc: {type: Array},
        },
        data: () => ({
            innerValue: null,
            emailFormIsValid: false,
            rules: [v => !!v || 'This field is required']
        }),
        methods: {
            cloneInner() {
                if (!this.value) {
                    this.innerValue = {
                        subject: '',
                        body: ''
                    };
                } else {
                    this.innerValue = JSON.parse(JSON.stringify(this.value));
                }
            },
            emitValue(event, type) {
                this.$set(this.innerValue, [type], event);
                const str = JSON.stringify(this.innerValue);
                if (str !== JSON.stringify(this.value)) {
                    this.$emit('input', JSON.parse(str));
                }
            },
            goToNext() {
                if (this.$refs.emailForm.validate()) {
                    this.$emit('next');
                }
            }
        },
        mounted() {
            !!this.value && this.cloneInner();
        },
        watch: {
            value() {
                this.cloneInner();
            }
        }
    }
</script>

<style scoped>

</style>